<template>
  <div class="page" v-if="can('article.show')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-translate</v-icon>
      إدارة المترجمين
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- FILTERS BOX -->
    <filters-box />

    <!-- RECORD INFO DIALOG -->
    <record-info />

    <!-- CREATE / UPDATE FROM -->
    <record-form @update="fetchRecords()" />

    <!-- UPDATE / NEW RECORD -->
    <div class="mb-3 mt-9 text-left">
      <v-btn
        v-if="can('article.store')"
        color="primary"
        elevation="0"
        @click="SET_RECORD_FORM({}); SET_EDIT_MODE(false); SHOW_RECORD_FORM()"
      >
        إضافة مترجم
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
    <!-- AUTHOR -->
      <template v-slot:item.image="{ item }">
        <img
          :src="item.image"
          width="50px"
          class="mt-3 mb-2 ml-2 rounded-lg"
        >
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="info"
          class="mx-2"
          @click="SET_CURRNET_RECORD(item); SHOW_RECORD_INFO()"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          small
          icon
          color="success"
          class="mx-2"
          @click="SET_RECORD_FORM(item); SET_EDIT_MODE(true); SHOW_RECORD_FORM()"
          v-if="can('article.edit')"
        >
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>

        <v-btn
          v-if="can('article.delete')"
          small
          icon
          color="error"
          class="mx-2"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        circle
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import RecordInfo from './RecordInfo';
import RecordForm from './RecordForm';
import FiltersBox from './FiltersBox';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'translators',
  components: { RecordInfo, RecordForm, FiltersBox },

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'رقم المترجم'
          },
          {
            value: 'image',
            text: 'المترجم'
          },
          {
            value: 'name',
            text: 'الاسم'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          }
        ],
        loading: false
      }
    }
  },

  computed: {
    ...mapState('translators', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    '$route': {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS(route.query);
        this.fetchRecords();
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations(
      'translators',
      [
        'SHOW_RECORD_FORM',
        'SET_EDIT_MODE',
        'SET_RECORD_FORM',

        'SHOW_RECORD_INFO',
        'SET_CURRNET_RECORD',

        'SET_FILTERS',
      ]
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('translators/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async remove(selectedRecord) {
      const confirmMessageParams = [
        `حذف المترجم رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من حذف المترجم ${selectedRecord.name}؟`,
        { color: 'error' }
      ];
      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('translators/delete', { recordId: selectedRecord.id })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم حذف المترجم بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            color: 'accent',
            text: 'تعذر حذف المترجم'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    }
  }
}
</script>
